import { ApexOptions } from 'apexcharts';
import ReactApexChart from 'react-apexcharts';
import { Col, Row } from 'react-bootstrap';

const DoubleComparisonColumnsChart = (props: {
  options: ApexOptions;
}) => {
  return (
    <div>
      <ReactApexChart options={props.options} type="bar" series={props.options.series} />
      <Row className="ps-11">
        <Col className="fw-light text-fs-6 lh-xs ps-12 text-center">
          We vs You Year-to-Date
        </Col>
        <Col className="fw-light text-fs-6 lh-xs ps-12 text-center">
          We vs You Annual Projection
        </Col>
      </Row>
    </div>
  );
};

export default DoubleComparisonColumnsChart;
